import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { requestTypes, groupActions } from './approvals_group_reducer';

const useGroupStatusRequest = (
  editMode,
  groupStatus,
  request,
  approvalGroupDispatch,
  editGroupUrl,
  changeStatusUrl,
  formRedirectUrl,
) => {
  if (!editMode) return;
  const submitStatusRequest =
    request.status &&
    (request.type === requestTypes.GROUP_STATUS ||
      request.type === requestTypes.DELETE_GROUP);
  let requestUrl = '';
  let method = '';
  let data = {};
  if (request.status && request.type === requestTypes.DELETE_GROUP) {
    requestUrl = editGroupUrl;
    method = 'DELETE';
  }
  if (request.status && request.type === requestTypes.GROUP_STATUS) {
    requestUrl = changeStatusUrl;
    method = 'PUT';
    const updatedStatus =
      groupStatus.status === 'active' ? 'archived' : 'active';
    data = JSON.stringify({ approval_group: { status: updatedStatus } });
  }
  const requestConfig = {
    method,
    url: submitStatusRequest ? requestUrl : null,
    data,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  const { data: httpData, error: httpError } = useHTTP(requestConfig);
  useEffect(() => {
    if (!httpData) return;
    if (httpData.success && request.type === requestTypes.GROUP_STATUS) {
      // When an active group is archived, redirect user to the group list page
      if (groupStatus.status === 'active') {
        window.location.assign(formRedirectUrl);
      }
      // Update initialLoadRequest to true to trigger a re-render of the page
      approvalGroupDispatch({
        type: groupActions.ENABLE_REQUEST,
        payload: { type: requestTypes.INITIAL_LOAD, params: '' },
      });
      return;
    }
    if (httpData.success && request.type === requestTypes.DELETE_GROUP) {
      // redirect user to the group list page after a successful delete
      window.location.assign(formRedirectUrl);
    }
    approvalGroupDispatch({ type: groupActions.DISABLE_REQUEST });
  }, [httpData]);
  useEffect(() => {
    if (!httpError) return;
    approvalGroupDispatch({ type: groupActions.DISABLE_REQUEST });
  }, [httpError]);
};
export default useGroupStatusRequest;
